import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import Index from './components/index.vue'
import AuthWechat from './components/auth-wechat.vue'
// import Show from './components/show.vue'
import ShowDetail from './components/show-detail.vue'
import EpisodeList from './components/episode-list.vue'
import IncomeIndex from './components/income-index.vue'
import CreateEpisode from './components/create-episode.vue'
import UpdateEpisode from './components/update-episode.vue'
import NoticeSetting from './components/notice-setting.vue'
import NoticeList from './components/notice-list.vue'
import UpdateNotice from './components/update-notice.vue'
import CreateNotice from './components/create-notice.vue'
import ResultSuccess from './components/result-success.vue'
import AccountBase from './components/account/base.vue'
import Register from './components/account/register.vue'
import Login from './components/account/login.vue'
import Logout from './components/account/logout.vue'
// import Shows from './components/account/shows.vue'
import Shows from './components/shows.vue'
import Price from './components/price.vue'
import Voucher from './components/voucher.vue'
import Swiper from './components/swiper.vue'
import Topic from './components/topic.vue'
import TopicSetting from './components/topic-setting.vue'
import TopicList from './components/topic-list.vue'
import CreateTopic from './components/create-topic.vue'
import UpdateTopic from './components/update-topic.vue'
import Recommend from './components/recommend.vue'
import VoucherSetting from './components/voucher-setting.vue'
import VoucherList from './components/voucher-list.vue'

Vue.use(VueRouter)

const routes = [
  // {path: '/', component: App},
  // {
  //   path: '/index',
  //   name: 'Index',
  //   component: Index
  // },
  {path: '/', name: 'Home', component: Shows},
  {
    path: '/index',
    name: 'App',
    component: App
  },
  {
    path: '/account', component: AccountBase,
    children: [
      {
        path: 'register',
        name: 'Register',
        component: Register
      },
      {
        path: 'login',
        name: 'Login',
        component: Login
      },
      {
        path: 'logout',
        name: 'Logout',
        component: Logout
      },
      {
        path: 'shows/',
        name: 'Shows',
        component: Shows
      }
    ]
  },
  {path: '/auth/wechat/', component: AuthWechat},
  {
    path: '/show/:slug', component: Index,
    children: [
      {
        path: 'home',
        name: 'ShowDetail',
        component: ShowDetail,
      },
      {
        path: 'income',
        name: 'IncomeIndex',
        component: IncomeIndex
      },
      {
        path: 'voucher-setting',
        name: 'VoucherSetting',
        component: VoucherSetting
      },
      {
        path: 'vouchers',
        name: 'VoucherList',
        component: VoucherList
      },
      {
        path: 'episodes',
        name: 'EpisodeList',
        component: EpisodeList
      },
      {
        path: 'create-episode',
        name: 'CreateEpisode',
        component: CreateEpisode
      },
      {
        path: 'update-episode/:id',
        name: 'UpdateEpisode',
        component: UpdateEpisode
      },
      {
        path: 'notice-setting',
        name: 'NoticeSetting',
        component: NoticeSetting
      },
      {
        path: 'notices',
        name: 'NoticeList',
        component: NoticeList
      },
      {
        path: 'notice/:id/update',
        name: 'UpdateNotice',
        component: UpdateNotice
      },
      {
        path: 'notice/create',
        name: 'CreateNotice',
        component: CreateNotice
      },
      {
        path: 'result/success',
        name: 'ResultSuccess',
        component: ResultSuccess
      },
      {
        path: 'price',
        name: 'Price',
        component: Price
      },
      {
        path: 'voucher',
        name: 'Voucher',
        component: Voucher
      },
      {
        path: 'swiper',
        name: 'Swiper',
        component: Swiper
      },
      {
        path: 'topic',
        name: 'Topic',
        component: Topic
      },
      {
        path: 'topic-setting',
        name: 'TopicSetting',
        component: TopicSetting
      },
      {
        path: 'topic-list',
        name: 'TopicList',
        component: TopicList
      },
      {
        path: 'topic/:id/update',
        name: 'UpdateTopic',
        component: UpdateTopic
      },
      {
        path: 'topic/create',
        name: 'CreateTopic',
        component: CreateTopic
      },
      {
        path: 'recommend',
        name: 'Recommend',
        component: Recommend
      },
    ]
  }
]
const router = new VueRouter({
  routes,
  linkActiveClass: 'active'
})
export default router
